import { ResourceMeta } from '../DomainResource/ResourceMeta';
import { DomainResource } from '../DomainResource/DomainResource';


/**
 * Subscribe into questionnaire filling events
 * 
 * 
 */ 

function QuestionnaireListener () {
  this.sendAnswersTimer = null;
  this.eventSendAnswers = this.eventSendAnswers.bind( this );
}


/**
 * Setup event listeners
 * 
 * @param object el
 * @return void
 */
QuestionnaireListener.prototype.startListening = function( el ) {
  //TODO: use correct name (anser added or something)
  el.addListener( 'questionnaire-force-send-answers',         this.eventSendAnswers );
}


/**
 * 
 * 
 * @param object eventIn
 */ 
QuestionnaireListener.prototype.eventSendAnswers = function( eventIn ) {
  this.scheduleAnswersPushToApi();
}


/**
 * -
 * 
 * @return void
 */ 
 QuestionnaireListener.prototype.scheduleAnswersPushToApi = function() {
  
  if ( this.sendAnswersTimer ) {
    clearTimeout( this.sendAnswersTimer );
  }

  var that = this;
  var resId = window.qHolder.getCurrentQuestionnaireResponseResourceId();
  var timeout = 700;
  if( window.appEntityStore.isLocalResourceId( resId ) ){
    // no time to wait- send immidetly if first message
    timeout = 10;
  }
  
  this.sendAnswersTimer = setTimeout( function(){
    that.sendAnswersTimer = null;
    
    var response  = window.qHolder.getCurrentQuestionnaireResponse();

    /*
    var currentToolSet = appState.getState( 'toolset' );
    var reference = currentToolSet.getPatientReference();

    if( reference ){
      response.subject = {
        "reference": reference.getReference(),
        "display": reference.getDisplayName()
      };
    } else {
      //return;
    }
    */

    // only 1 patient should be in store - one who logged in
    // dont add name if anonymous -> "display": reference.getDisplayName()
    var patients = window.appEntityStore.getAllResourcesBySearchParams( {
      "resourceType" : "Patient"
    } );

    if( typeof patients[ 0 ] != 'undefined' ){
      let patient = patients[ 0 ].toObject();
      response.subject = {
        "reference": "Patient/" + patient.id
      };
    }
    
    console.log( response.subject );

    
    // encounter reference added only if new resource
    //var encounter = window.encounterState.getGlobalEncounterJsonForResource();
    
    //response.encounter = encounter;

    var resId           = window.qHolder.getCurrentQuestionnaireResponseResourceId();
    var domainResource  = window.appEntityStore.getResourceById( resId );
    //var overallProgress = window.qHolder.getCurrentOverallProgressPercentage();

    if( !domainResource ){
      var domainResource = new DomainResource( "QuestionnaireResponse" );
      domainResource.setRawResourceObject( response );
      domainResource.setId( resId );
      domainResource.setResourceMeta( window.appEntityStore.getResourceMetaWithOnlyNewSourceUrl( 'QuestionnaireResponse' ) );
      console.log( "Send QuestionnaireResponse with NEW DR and ID: " + domainResource.getId() );
    } else {
      response.status = domainResource.getStatus(); // keep original status unless 100% done
      let previousJson = domainResource.toObject();
      //if( overallProgress >= 100 ){
      //  response.status = 'completed';
      // }
      
      console.log( "Just paste over "); 
      console.log(  response ); 
      // copy some data just over
      if( typeof previousJson.encounter !== "undefined" ){
        response.encounter = previousJson.encounter;
      }

      if( typeof previousJson.extension !== "undefined" ){
        response.extension = previousJson.extension;
      }

      if( typeof previousJson.authored !== "undefined" ){
        response.authored = previousJson.authored;
      }

      if( typeof previousJson.author !== "undefined" ){
        response.author = previousJson.author;
      }
      console.log(  response ); 


      domainResource.setRawResourceObject( response );
      console.log( "Send QuestionnaireResponse with existing DR and ID: " + domainResource.getId() + " / timeout: " + timeout );
    }

    if( typeof window !== "undefined" && typeof window.appLastGuidaneResesponse2 !== "undefined" ){
      window.appLastGuidaneResesponse2.isWaiting = true;
    }
    
    window.appEntityStore.saveResource( domainResource );
    // window.eventsEmitter.emit( 'entities-updated', { 'source' : 'self', 'entityTypes' : ['QuestionnaireResponse'] } );
   
  } , timeout );
}


export default QuestionnaireListener;
